import React from 'react';
import Countdown from 'react-countdown-now';
import './countdownStyles.scss';
import moment from 'moment/moment';
import config from '../../../config';

let request;

class EventCountdown extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.events = this.props.section.prop('events');
    this.upcomingEventDate = null;
    this.upcomingEventName = null;
    this.upcomingEvent = null;
    this.calculateEvent = this.calculateEvent.bind(this);
    let calendars = this.props.section.prop('calendars');
    this.state = {
      calendarEvents: []
    };
    this.API_KEY = 'AIzaSyD0iq6kqEnh8mr1-42nAudojdElsGTRte0';
    import('superagent').then((mod) => {
      request = mod.default;
      calendars.forEach(calendar => {
        const options = this.props.section.prop('countdown_options') || {};
        const daysInAdvance = options.daysInAdvance || 62;
        this.getEvents(calendar.id, daysInAdvance, 10, calendar.color, events => {
          this.state.calendarEvents.push(events);
          this.forceUpdate();
        });
      });
    });
  }

  componentDidMount() {
    this.calculateEvent();
  }

  static getEaster(year) {
    year = year || new Date().getFullYear();
    let f = Math.floor,
      // Golden Number - 1
      G = year % 19,
      C = f(year / 100),
      // related to Epact
      H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
      // number of days from 21 March to the Paschal full moon
      I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
      // weekday for the Paschal full moon
      J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
      // number of days from 21 March to the Sunday on or before the Paschal full moon
      L = I - J,
      month = 3 + f((L + 40) / 44),
      day = L + 28 - 31 * f(month / 4);
    return new Date(month + '/' + day + '/' + year);
  }

  getNextUpcomingEvent(events) {
    let today = new Date();
    events.forEach(event => {
      const eventDate = event.startMoment
        ? event.startMoment.toDate()
        : new Date(event.date);
      if (!this.upcomingEventDate || eventDate < this.upcomingEventDate) {
        if (this.upcomingEventDate <= today)
          this.upcomingEventName = event.name || event.title; //Set the name even if the event has passed as long as we don't have an event yet
        if (eventDate > today) {
          this.upcomingEventName = event.name || event.title;
          this.upcomingEventDate = eventDate;
          this.upcomingEvent = event;
        }
      }
    });
  }

  getEvents(calendarID, daysInAdvance, maxEvents, eventColor, callback) {
    let now = moment();
    const earliestDay = now.format();
    const lastDay = now.add(daysInAdvance, 'days').format();
    request
      .get(
        config.API_ROOT +
          `/calendar-proxy/${encodeURIComponent(calendarID)}/events?key=${
            this.API_KEY
          }&singleEvents=True` +
          '&timeMin=' +
          earliestDay +
          '&timeMax=' +
          lastDay
      )
      .end((err, resp) => {
        if (!err) {
          let events = [];
          JSON.parse(resp.text).items.map(event => {
            const startDate = event.start.dateTime || event.start.date;
            const endDate = event.end.dateTime || event.end.date;
            let startMoment = moment(startDate);
            let start = startDate.includes('T')
              ? startDate.split('T')[0]
              : startDate;
            let endMoment = moment(endDate);
            let end = startDate.includes('T')
              ? startDate.split('T')[0]
              : startDate;
            let startTime, endTime;
            if (startMoment.day() !== endMoment.day()) {
              startTime = startMoment.format('M-D-Y');
              endTime = endMoment.format('M-D-Y');
            } else {
              startTime = startMoment.format('h:mm a');
              endTime = endMoment.format('h:mm a');
            }
            events.push({
              start: start,
              end: end,
              startTime: startTime,
              endTime: endTime,
              title: event.summary,
              description: event.description,
              endMoment: endMoment,
              startMoment: startMoment,
              location: event.location,
              color: eventColor
            });
          });
          events = this.sortEvents(events);
          callback(events);
        }
      });
  }

  sortEvents(events) {
    return events.sort((e, e2) => {
      return e.startMoment.isSameOrAfter(e2.startMoment) ? 1 : -1;
    });
  }

  calculateEvent() {
    let today = new Date();
    this.upcomingEventDate = null;
    const chronologicalEvents = this.sortEvents(
      [].concat.apply([], this.state.calendarEvents)
    );
    this.getNextUpcomingEvent(chronologicalEvents);
    const onEmpty = this.props.section.prop('countdown_options').onEmpty;
    if (!this.upcomingEventDate) {
      if (onEmpty === 'zero') this.upcomingEventDate = today;
      else if (onEmpty === 'holiday') {
        const easter = EventCountdown.getEaster();
        const dayLength = 1000 * 60 * 60 * 24;
        const holidays = [
          {
            name: 'Palm Sunday',
            date: new Date(easter.getTime() - dayLength * 7)
          },
          {
            name: 'Maundy Thursday',
            date: new Date(easter.getTime() - dayLength * 3)
          },
          {
            name: 'Good Friday',
            date: new Date(easter.getTime() - dayLength * 2)
          },
          {
            name: 'Easter Sunday',
            date: new Date(easter.getTime())
          },
          {
            name: 'Pentecost',
            date: new Date(easter.getTime() + dayLength * 40)
          },
          {
            name: 'Christmas',
            date: new Date('12/25/' + new Date().getFullYear())
          }
        ];
        this.getNextUpcomingEvent(holidays);
      }
    }
  }

  render() {
    const onEmpty = this.props.section.prop('countdown_options').onEmpty;
    this.calculateEvent();
    const className = this.props.section.prop('countdown_style');
    let showBackground = false;
    switch (className) {
      case 'default':
        showBackground = false;
        break;
      case 'squares':
        showBackground = true;
        break;
      case 'circles':
        showBackground = true;
        break;
    }
    const shadowCSS = this.props.section.ls('text-shadow')
      ? this.props.section.ls('text-shadow').shadow_css
      : '';
    const options = this.props.section.prop('countdown_options');
    const font = options.font;
    const defaultColor = options.textColor || '#aaa';
    const unitStyle = {
      color: this.upcomingEvent
        ? this.upcomingEvent.color
          ? this.upcomingEvent.color
          : defaultColor
        : defaultColor,
      backgroundColor: showBackground
        ? options.backgroundColor || '#fff'
        : 'rgba(0,0,0,0)'
    };
    if (font && font !== 'default') unitStyle.fontFamily = font;
    // Renderer callback with condition
    const renderer = ({days, hours, minutes, seconds, completed}) => {
      // Render a countdown
      if (completed) {
        days = 0;
        hours = 0;
        minutes = 0;
        seconds = 0;
      }
      const showUnits = options.showUnits;
      return (
        <span className="countdownContainer">
          <span className="countdownUnit">
            <span className={className} style={unitStyle}>
              <div className="countdownValue">{days}</div>
              {showUnits ? (
                <div className="unitLabel">
                  Day{parseInt(days) !== 1 ? 's' : ''}
                </div>
              ) : null}
            </span>
          </span>
          <span className="countdownUnit">
            <span className={className} style={unitStyle}>
              <div className="countdownValue">{hours}</div>
              {showUnits ? (
                <div className="unitLabel">
                  Hour{parseInt(hours) !== 1 ? 's' : ''}
                </div>
              ) : null}
            </span>
          </span>
          <span className="countdownUnit">
            <span className={className} style={unitStyle}>
              <div className="countdownValue">{minutes}</div>
              {showUnits ? (
                <div className="unitLabel">
                  Minute{parseInt(minutes) !== 1 ? 's' : ''}
                </div>
              ) : null}
            </span>
          </span>
          <span className="countdownUnit">
            <span className={className} style={unitStyle}>
              <div className="countdownValue">{seconds}</div>
              {showUnits ? (
                <div className="unitLabel">
                  Second{parseInt(seconds) !== 1 ? 's' : ''}
                </div>
              ) : null}
            </span>
          </span>
        </span>
      );
    };
    return (
      <div
        style={{textAlign: 'center', margin: '0 auto', paddingBottom: '30px'}}
      >
        {this.upcomingEventDate ? (
          <span style={{textShadow: shadowCSS}}>
            <h3
              className="countdownTitle"
              id={'countdownTitle-' + this.props.section.get('id')}
            >
              {this.upcomingEventName}
            </h3>
            <Countdown date={this.upcomingEventDate} renderer={renderer} />
          </span>
        ) : null}
      </div>
    );
  }
}

export default EventCountdown;
